import { Exclude } from 'class-transformer';
import { UpdatedResultDto } from '../../common/updated-result-dto';

export class GLJournalAttachmentRawDto extends UpdatedResultDto {
    description: string;
    fileDataBase64: string; // Required

    fileName: string; // Required
    fileStoreID: number;
    crudAction: string;

    @Exclude()
    downloadUrl: string;
}
